import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';

import './SocialShareButtons.module.css';

const SocialShareButtons = ({ title, type, url, t }) => {
  const shareURL = `https://www.formlabs.com${url}`;
  const postTitle = title.replace('&', '%26');
  const postType = type.replace('&', '%26');

  return (
    <div styleName="social-share-links">
      <div styleName="social-button">
        <a
          href={encodeURI(
            `https://www.facebook.com/sharer/sharer.php?u=${shareURL}&title=${postTitle}`
          )}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={t('Share on Facebook')}
        >
          <i className="fl-facebook" />
        </a>
      </div>
      <div styleName="social-button">
        <a
          href={encodeURI(
            `https://www.twitter.com/intent/tweet?text=${postTitle}
${t('Learn More')}: ${shareURL}`
          )}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={t('Share on Twitter')}
        >
          <i className="fl-twitter" />
        </a>
      </div>
      <div styleName="social-button">
        <a
          href={encodeURI(
            `mailto:?subject=Formlabs ${postType}: ${postTitle}&body=${postTitle}: ${shareURL}`
          )}
          aria-label={t('Share as email')}
        >
          <i className="fl-mail" />
        </a>
      </div>
    </div>
  );
};

SocialShareButtons.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

SocialShareButtons.defaultProps = {
  type: null
};

export default DisplayComponent(withTranslation()(SocialShareButtons));
